import { gsap } from 'gsap';

let isAnimating = false;

export const openOverlay = (container) => {
    if (isAnimating) return;
    isAnimating = true;

    const path = container.querySelector('.js-overlay-animate');
    const childItems = container.querySelectorAll('.js-overlay-child');

    const tl = gsap.timeline({
        onStart: () => {
            document.documentElement.style.overflow = 'hidden';
            gsap.set(container, {
                opacity: 1,
            });
        },
        onComplete: () => {
            isAnimating = false;
        },
    });

    tl.set(path, {
        attr: { d: 'M 0 100 V 100 Q 50 100 100 100 V 100 z' },
    })
        .to(path, {
            duration: 0.6,
            ease: 'power4.in',
            attr: { d: 'M 0 100 V 50 Q 50 0 100 50 V 100 z' },
        }, 0)
        .to(path, {
            duration: 0.3,
            ease: 'power2',
            attr: { d: 'M 0 100 V 0 Q 50 0 100 0 V 100 z' },
            onComplete: () => {
                container.classList.add('is-open');

                if (container.classList.contains('js-search')) {
                    document.querySelector('.js-search-form .ais-SearchBox-input').focus();
                }
            },
        })
        .to(document.querySelectorAll('.js-animate-section'), {
            duration: 0.6,
            ease: 'power3.in',
            y: -200,
            stagger: 0.05,
        }, 0.2)
        .set(childItems, {
            opacity: 0,
        })
        .set(path, {
            attr: { d: 'M 0 0 V 100 Q 50 100 100 100 V 0 z' },
        })
        .to(path, {
            duration: 0.3,
            ease: 'power2.in',
            attr: { d: 'M 0 0 V 50 Q 50 0 100 50 V 0 z' },
        })
        .to(path, {
            duration: 0.6,
            ease: 'power4',
            attr: { d: 'M 0 0 V 0 Q 50 0 100 0 V 0 z' },
        })
        .to(childItems, {
            duration: 1.1,
            ease: 'power4',
            startAt: { y: 150 },
            y: 0,
            opacity: 1,
            stagger: 0.05,
        }, '>-=1.1');
};

export const closeOverlay = (container) => {
    if (isAnimating) return;
    isAnimating = true;

    const path = container.querySelector('.js-overlay-animate');
    const childItems = container.querySelectorAll('.js-overlay-child');

    const tl = gsap.timeline({
        onComplete: () => {
            document.documentElement.style.overflow = '';
            isAnimating = false;
        },
    });

    tl.set(path, {
        attr: { d: 'M 0 0 V 0 Q 50 0 100 0 V 0 z' },
    })
        .to(path, {
            duration: 0.6,
            ease: 'power4.in',
            attr: { d: 'M 0 0 V 50 Q 50 100 100 50 V 0 z' },
        }, 0)
        .to(path, {
            duration: 0.3,
            ease: 'power2',
            attr: { d: 'M 0 0 V 100 Q 50 100 100 100 V 0 z' },
            onComplete: () => {
                container.classList.remove('is-open');
            },
        })
        .set(path, {
            attr: { d: 'M 0 100 V 0 Q 50 0 100 0 V 100 z' },
        })
        .to(path, {
            duration: 0.3,
            ease: 'power2.in',
            attr: { d: 'M 0 100 V 50 Q 50 100 100 50 V 100 z' },
        })
        .to(path, {
            duration: 0.6,
            ease: 'power4',
            attr: { d: 'M 0 100 V 100 Q 50 100 100 100 V 100 z' },
        })
        .to(document.querySelectorAll('.js-animate-section'), {
            duration: 1.1,
            ease: 'power4',
            y: 0,
            stagger: -0.05,
        }, '>-=1.1')
        .to(childItems, {
            duration: 0.6,
            ease: 'power2.in',
            y: 100,
            opacity: 0,
            stagger: -0.05,
        }, 0);
};
